import {
  FormControls,
  SaveButton,
} from "../../../../components/flyer-detail-page-form/flyer-detail-page-form.styles";
import { FlyerDetailPageFormPositionLanguageSelect } from "../flyer-detail-page-form-position-language-select/flyer-detail-page-form-position-language-select.component";
import { TextField } from "../../../../../../../../../../features/forms/fields/text-field/text-field.component";
import { FlyerDetailPageFormPositionGetCopy } from "../flyer-detail-page-form-position-get-copy/flyer-detail-page-form-position-get-copy.component";
import { hasGetProducts } from "../../../../../../../../../../types/product/ibrief-product/ibrief-product.functions";
import { FlyerDetailPageFormPositionGetProductImageUrl } from "../flyer-detail-page-form-position-get-product-image-url/flyer-detail-page-form-position-get-product-image-url.component";
import { FlyerDetailPageFormPositionDateFields } from "../flyer-detail-page-form-position-date-fields/flyer-detail-page-form-position-date-fields.component";
import React, { useRef } from "react";
import { FlyerDetailPageFormPositionViewProps } from "./flyer-detail-page-form-position-view.props";
import { withShowIf } from "../../../../../../../../../../components/with-show-if/with-show-If.component";
import { FlyerDetailPageFormPositionCategories } from "../flyer-detail-page-form-position-categories/flyer-detail-page-form-position-categories.component";
import { FlyerDetailPageFormPositionProductsTable } from "../flyer-detail-page-form-position-products-table/flyer-detail-page-form-position-products-table.component";
import {
  ReadonlyField,
  ReadonlyFieldLabel,
} from "../../../../../../../../../../components/form-controls/readonly-field/readonly-field.component";
import { IFormRef } from "../../../../../../../../../../features/forms/types/forms.interface";
import { createFormRef } from "../../../../../../../../../../features/forms/types/forms.functions";
import { useControlForm } from "../../../../../../../../../../features/forms/forms.hook";
import { createFlyerDetailPagePositionForm } from "../../types/flyer-detail-page-position-form.functions";
import { FlyerDetailPageFormPositionMerchOwners } from "../flyer-detail-page-form-position-merch-owners/flyer-detail-page-form-position-merch-owners.component";
import { FlyerDetailPageFormPositionControls } from "./flyer-detail-page-form-position-view.styles";
import { makeKey } from "../../../../../../../../../../utils/helpers";
import { PositionCategory } from "../../types/flyer-detail-page-form-position-categories/flyer-detail-page-form-position-categories.interface";

export const FlyerDetailPageFormPositionView = withShowIf(
  (props: FlyerDetailPageFormPositionViewProps) => {
    const formRef = useRef<Partial<IFormRef>>(createFormRef());

    const form = useControlForm({
      defaultValues: createFlyerDetailPagePositionForm(props.position),
      formRef,
    });

    const copy = (): string => `copies[${props.languageIndex}]`;

    const getCategories = () => form.getValues().categories;

    const onAddCategory = (category: PositionCategory) =>
      form.setValue("categories", getCategories().concat([category]));

    const onRemoveCategory = (category: PositionCategory) =>
      form.setValue(
        "categories",
        getCategories().filter((c: PositionCategory) => c.id !== category.id)
      );

    return (
      <>
        <FormControls>
          <FlyerDetailPageFormPositionCategories
            categories={getCategories()}
            permissions={props.permissions}
            onAddCategory={onAddCategory}
            onRemoveCategory={onRemoveCategory}
          />

          <FlyerDetailPageFormPositionMerchOwners merchOwners={props.position.merchOwners} />

          <FlyerDetailPageFormPositionControls>
            <SaveButton disabled={!form.isDirty} onClick={form.handleSubmit(props.onSave)}>
              Save
            </SaveButton>
          </FlyerDetailPageFormPositionControls>

          <FlyerDetailPageFormPositionLanguageSelect
            selectedLanguage={props.selectedLanguage}
            onSelect={props.onSelectLanguage}
          />

          <TextField
            form={form}
            key={makeKey("cc", props.selectedLanguage)}
            label="Copy Card"
            name={`${copy()}.copyCard`}
            userPermissions={props.permissions}
          />

          <FlyerDetailPageFormPositionGetCopy
            key={makeKey("gcc", props.selectedLanguage)}
            showIf={hasGetProducts(props.position.products)}
            languageIndex={props.languageIndex}
            form={form}
            userPermissions={props.permissions}
          />

          <TextField
            form={form}
            key={makeKey("pil", props.selectedLanguage)}
            label="Product Image Location"
            name={`${copy()}.productImage`}
            userPermissions={props.permissions}
          />

          <FlyerDetailPageFormPositionGetProductImageUrl
            key={makeKey("hgp", props.selectedLanguage)}
            showIf={hasGetProducts(props.position.products)}
            copyFieldPath={copy()}
            userPermissions={props.permissions}
            form={form}
          />

          <TextField
            form={form}
            key={makeKey("bll", props.selectedLanguage)}
            label="Brand Logo Location"
            name={`${copy()}.brandLogo`}
            userPermissions={props.permissions}
          />

          <FlyerDetailPageFormPositionDateFields
            startDate={props.position.dealStartDate}
            endDate={props.position.dealEndDate}
          />

          <ReadonlyField>
            <ReadonlyFieldLabel>Savings Badge</ReadonlyFieldLabel>
            {props.position.badge}
          </ReadonlyField>

          <FlyerDetailPageFormPositionProductsTable
            flyerEndDatePassed={props.flyerEndDatePassed}
            positionId={props.position.id}
            products={props.position.products}
          />
        </FormControls>
      </>
    );
  }
);
